import request from "./request";
/**
 * 发帖
 * @param imageFile 上传图片
 * @param content 贴文信息
 * @param link 链接
 * @param pageName 专页名称
 * @param pageId 专页id
 * @param sendType 发送类型 1-链接 2-图片
 * @param sendTime 发布时间（如果是立即发送传入当前时间，如果是定时发送传入定时发送时间）
 * @param timeInterval 定时时间间隔
 * @param status 发布状态 1-已发布 2-已删除 3-待发布  （如果立即发送传1 定时发布传3）
 */
export default async function addSend(data) {
  return await request.post("/spin/dataSend/addSend", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
